export const ALLOCATE_SHIPPING_UNIT_LIST_COLUMN = "ALLOCATE_SHIPPING_UNIT_LIST_COLUMN";